export default function IconSearch() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="28"
        cy="28"
        r="25.7895"
        stroke="#F77D7D"
        strokeWidth="4.42105"
      />
      <path
        d="M19.9616 39.2656C19.2542 39.2656 18.6647 39.0769 18.1932 38.6997C17.7452 38.2988 17.4858 37.8155 17.4151 37.2496C17.3443 36.6601 17.533 36.0588 17.981 35.4458L25.7974 25.0828V27.5233L18.2993 17.5494C17.8513 16.9127 17.6509 16.3115 17.698 15.7456C17.7687 15.1561 18.0281 14.6727 18.4761 14.2955C18.9477 13.8946 19.5254 13.6942 20.2092 13.6942C20.7986 13.6942 21.3056 13.8357 21.73 14.1186C22.178 14.4016 22.626 14.8496 23.074 15.4626L28.9098 23.5266H27.1414L32.9418 15.4626C33.3898 14.826 33.8378 14.378 34.2858 14.1186C34.7338 13.8357 35.2525 13.6942 35.842 13.6942C36.5494 13.6942 37.1271 13.8828 37.5751 14.2601C38.0466 14.6374 38.306 15.1207 38.3532 15.7102C38.4239 16.2761 38.2235 16.8892 37.7519 17.5494L30.2184 27.5233V25.0828L37.9995 35.4458C38.4711 36.0588 38.6715 36.6601 38.6007 37.2496C38.5536 37.8155 38.2942 38.2988 37.8226 38.6997C37.3746 39.0769 36.7852 39.2656 36.0542 39.2656C35.4883 39.2656 34.9814 39.1241 34.5334 38.8412C34.109 38.5582 33.661 38.0984 33.1894 37.4618L27.106 29.0795H28.9098L22.8264 37.4618C22.3784 38.0984 21.9304 38.5582 21.4824 38.8412C21.0344 39.1241 20.5275 39.2656 19.9616 39.2656Z"
        fill="#F77D7D"
      />
    </svg>
  )
}
